import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { ToastModule } from 'primeng/toast';
import { UnauthWrapperModule } from '../unauth-wrapper/unauth-wrapper.module';
import { TenapodExternalRedirectAuthRoutingModule } from './tenapod-external-redirect-auth-routing.module';
import { TenapodExternalRedirectAuthComponent } from './tenapod-external-redirect-auth/tenapod-external-redirect-auth.component';

@NgModule({
  declarations: [TenapodExternalRedirectAuthComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    ToastModule,
    UnauthWrapperModule,
    TenapodExternalRedirectAuthRoutingModule,
  ],
})
export class TenapodExternalRedirectAuthModule {}
